/**
 * @description used to transform result from ORDERS CREATE Api of api-gateway
 * @api - /checkout/order/create/v2 .
 *
 */
import { payUPaymentRequestDTOTransformer } from "./payUPaymentRequestDTOTransformer";
import { orderDataTransformer } from "./orderDataTransformer";
import { upiPaymentRequestDTOTransformer } from "./upiPaymentRequestDTOTransformer";
import { razorpayRequestDTOTransformer } from "./razorpayRequestDTOTransformer";
import { cashFreeRequestDTOTransformer } from "./cashFreeRequestDTOTransformer";
import { cashFreeSeamlessDTOTransformer } from "./cashFreeSeamlessDTOTransformer";
import { itemTransformer } from "./itemTransformer";

interface ResponseType {
  items: object;
  cod_delay_message: string;
  is_new_user: boolean;
  paymentStatus: string;
  paymentGateway: string;
  orderState: string;
  paytmRequestDTO: object;
  payUPaymentRequestDTO: object;
  paymentExtraParamsDTO: object;
  razorPayPaymentRequestDTO: object;
  refer_a_friend: string;
  shipping_address: object;
  upiPaymentRequestDTO: object;
  cashfreePaymentRequestDTO: object;
  cashfreeSeamlessPaymentRequestDTO: object;
  hashValue: string;
  bankcode: string;
  paymentInitiationRequestDTO: object;
  totalAmount: number;
  paymentMode: string;
  paymentOfferApplied: boolean;
  masterPaymentStatus: string;
  showFallbackModes: boolean;
  savedOption?: boolean;
  walletAmountUsed?: number;
  postPaymentStatusDto?: { amount: number; mode: string }[];
  giftCard?: {
    giftCardAmountUsed: number;
    giftCardNumber: string;
    pin: string;
    giftCardBalance: number;
  };
  remarks: string;
  autoOrderEligible: boolean;
}

export const getOrdersPaymentResponseTransformer = (response: ResponseType) => {
  let transformedItems = itemTransformer(response.items || []);

  return {
    codDelayMessage: response.cod_delay_message || "",
    isNewUser: response.is_new_user || -1,
    items: transformedItems,
    orderData: orderDataTransformer(response || {}),
    paymentStatus: response.paymentStatus || "",
    paymentGateway: response.paymentGateway || "",
    orderStatus: response.orderState || "",
    paytmRequestDTO: response.paytmRequestDTO || {},
    payUPaymentRequestDTO: payUPaymentRequestDTOTransformer(response.payUPaymentRequestDTO || {}),
    paymentExtraParamsDTO: response.paymentExtraParamsDTO || {},
    razorPayPaymentRequestDTO: razorpayRequestDTOTransformer(
      response.razorPayPaymentRequestDTO || {}
    ),
    referAFriend: response.refer_a_friend || {},
    shippingAddress: response.shipping_address || {},
    upiPaymentRequestDTO: upiPaymentRequestDTOTransformer(response.upiPaymentRequestDTO || {}),
    cashfreePaymentRequestDTO: cashFreeRequestDTOTransformer(
      response.cashfreePaymentRequestDTO || {}
    ),
    cashfreeSeamlessPaymentRequestDTO: cashFreeSeamlessDTOTransformer(
      response.cashfreeSeamlessPaymentRequestDTO || {}
    ),
    hashValue: response.hashValue || "", // added for PaymentSuccess incase of guest users
    paymentInitiationRequestDTO: response?.paymentInitiationRequestDTO,
    totalAmount: response?.totalAmount || 0,
    paymentMode: response?.paymentMode || "",
    paymentOfferApplied: response?.paymentOfferApplied || false,
    masterPaymentStatus: response.masterPaymentStatus || "",
    showFallbackModes: response.showFallbackModes || false,
    walletAmountUsed:
      response.postPaymentStatusDto?.find(ele => ele.mode === "wallet")?.amount || 0,
    giftCard: response.giftCard || {}, // TO DO - change later if required
    isSavedPayment: response.savedOption || false,
    remarks: response?.remarks || "",
    autoOrderEligible: response?.autoOrderEligible || false
  };
};
